import { render, staticRenderFns } from "./CallForTenders.vue?vue&type=template&id=32db2ce6&scoped=true"
import script from "./CallForTenders.vue?vue&type=script&lang=js"
export * from "./CallForTenders.vue?vue&type=script&lang=js"
import style0 from "./CallForTenders.vue?vue&type=style&index=0&id=32db2ce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32db2ce6",
  null
  
)

export default component.exports